import { render, staticRenderFns } from "./ClickableAdspaceItem.vue?vue&type=template&id=4a062ae4&scoped=true&"
import script from "./ClickableAdspaceItem.vue?vue&type=script&lang=ts&"
export * from "./ClickableAdspaceItem.vue?vue&type=script&lang=ts&"
import style0 from "./ClickableAdspaceItem.vue?vue&type=style&index=0&id=4a062ae4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a062ae4",
  null
  
)

export default component.exports